module.exports = __webpack_public_path__ + "static/header-bg-2c70f3874fcc33bab22f44d76bca7cd1.jpg";